import { useState } from "react";

interface Item {
    label: string,
    key: number,
    children: React.ReactNode
}

interface IProps {
    items: Array<Item>
    defaultkey?: number;
    classNames?: { defaultHeader?: string, activeHeader?: string, children?: string }
    styles?: { container?: React.CSSProperties, header?: React.CSSProperties, defaultHeader?: React.CSSProperties, activeHeader?: React.CSSProperties, children?: React.CSSProperties }
    onClick?: (key: number) => void
}

const CustomTabs = ({ items, defaultkey = 0, classNames, styles, onClick }: IProps) => {
    const [key, setKey] = useState<number>(defaultkey);

    const HEADERHEIGHT = 40;
    const anchorHeaderStyle = {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: `${HEADERHEIGHT}px`,
        flex: 1,
        cursor: 'pointer',
    }

    const activeHeaderStyle = {
        color: 'var(--baseblack)',
        borderBottom: '2px solid black',
        ...anchorHeaderStyle,
        ...styles?.activeHeader,
        ...styles?.header,
    }
    const defaultHeaderStyle = {
        color: 'var(--secondarys600)',
        borderBottom: '1px solid #F4F4F4',
        ...anchorHeaderStyle,
        ...styles?.defaultHeader,
        ...styles?.header,
    }

    return <>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', textAlign: 'center', ...styles?.container }}>
            {items.map((item: Item, idx) => <div key={idx}
                className={"sub-title/st2 " + (key === item.key ? classNames?.activeHeader ?? '' : classNames?.defaultHeader ?? '')}
                style={key === item.key ? activeHeaderStyle : defaultHeaderStyle}
                onClick={() => { onClick?.(item.key); setKey(item.key) }}>
                {item.label}
            </div>)}
        </div>
        <div className={classNames?.children ?? undefined} style={styles?.children}>
            {items.map((item) => (
                <div
                    key={item.key}
                    style={{ display: key === item.key ? 'block' : 'none' }}
                >
                    {item.children}
                </div>
            ))}
        </div>
    </>
}

export { CustomTabs }